import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
`;

export const TopSection = styled.div`
  display: flex;
  padding: 0px 24px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

export const Title = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
`;

export const ListContainer = styled.div`
  display: flex;
  min-width: 980px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

export const HeaderContainer = styled.div`
  display: flex;
  min-width: 738px;
  padding: 12px 24px;
  align-items: center;
  align-self: stretch;
  gap: 32px;

  border-radius: 12px;
  background: var(--component-color-fill-alternative);
`;

export const LabelContainer = styled.div<{ minWidth: number; maxWidth: number }>`
  display: flex;
  min-width: ${({ minWidth }) => minWidth}px;
  max-width: ${({ maxWidth }) => maxWidth}px;
  align-items: center;
  flex: 1 0 0;
`;

export const EmptyLow = styled.div`
  display: flex;
  padding: 12px 24px;
  align-items: center;
  gap: 8px;
  align-self: stretch;

  border-bottom: 1px solid var(--alias-color-line-normal);
`;
